import React, { useEffect, useState } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import EnTetePage from "../../components/charte/EnTetePage";
import Bloc from "../../components/charte/Bloc";
import { BoutonPrincipal, BoutonSecondaire } from "../../components/charte/Boutons";
import { AIDE_FACTURATION } from "../../aide/textesAide";
import { STYLE_TON } from "../../theme/tribeTheme";
import { messageServeur } from "../../utilities/userService";
import { VueClient, listerClients } from "../../utilities/facturationService";
import { DialogClient, Erreur } from "./composantsFacturation";

/* Argent › Clients facturés : l'identité que portent les documents émis. Un
   client se rattache à une quête depuis le bloc Facturation de sa fiche. */
export default function ClientsFactures() {
  const [clients, setClients] = useState<VueClient[]>([]);
  const [erreur, setErreur] = useState<string | null>(null);
  const [fiche, setFiche] = useState<VueClient | null | "nouveau">(null);
  const charger = () => listerClients().then(setClients).catch((e) => setErreur(messageServeur(e, "Clients illisibles.")));
  useEffect(() => { charger(); }, []);
  const identifiant = (v: VueClient) => {
    const c = v.client;
    return [c.ninea && `NINEA ${c.ninea}`, c.ncc && `NCC ${c.ncc}`, c.rccm && `RCCM ${c.rccm}`,
      c.identifiantFiscal && `IF ${c.identifiantFiscal}`].filter(Boolean).join(" · ") || "—";
  };
  return (
    <Box sx={{ p: { xs: 2, md: 3.5 }, maxWidth: 1280 }}>
      <EnTetePage domaine="argent" titre="Clients facturés" aide={AIDE_FACTURATION.clients}
        phrase="Raison sociale, identifiants fiscaux, TVA, contact et compte du portail des clients à qui Tribe facture."
        actions={<BoutonPrincipal onClick={() => setFiche("nouveau")}>Nouveau client</BoutonPrincipal>} />
      <Erreur message={erreur} />
      <Bloc>
        {clients.length === 0 ? (
          <Typography sx={{ fontSize: 14, color: "var(--c-text-secondary)" }}>Aucun client facturé pour l'instant.</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>{["Client", "Pays", "Identifiants fiscaux", "TVA", "Contact", "État", ""].map((h) => <TableCell key={h}>{h}</TableCell>)}</TableRow>
            </TableHead>
            <TableBody>
              {clients.map((v) => (
                <TableRow key={v.client.id}>
                  <TableCell><b>{v.client.raisonSociale}</b></TableCell>
                  <TableCell>{v.client.pays}</TableCell>
                  <TableCell>{identifiant(v)}</TableCell>
                  <TableCell>{v.client.motifExonerationTva ? "exonéré" : v.client.numeroTva ?? "—"}</TableCell>
                  <TableCell>{[v.client.contactNom, v.client.contactEmail].filter(Boolean).join(" · ")}</TableCell>
                  <TableCell>
                    {v.complet
                      ? <Typography sx={{ fontSize: 12.5, color: STYLE_TON.succes.color }}>complet</Typography>
                      : <Typography sx={{ fontSize: 12.5, color: STYLE_TON.erreur.color }}>manque : {v.manquants.join(", ")}</Typography>}
                  </TableCell>
                  <TableCell align="right"><BoutonSecondaire size="small" onClick={() => setFiche(v)}>Modifier</BoutonSecondaire></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Bloc>
      <DialogClient ouvert={fiche !== null} vue={fiche === "nouveau" ? null : fiche} onFerme={() => setFiche(null)}
        onEnregistre={() => { setFiche(null); charger(); }} />
    </Box>
  );
}
